import axios from "axios";
import { baseUrl, extendHeaders, headers } from "./HelpService";


const PageUrl = baseUrl + 'users/';


const getUserDetails = (user_id: number): Promise<Response | null> => {
    var url = PageUrl + 'getUser/';
    if (user_id)
        url += `?user_id=${user_id}`
    return fetch(url, {
        method: "GET",
        headers: extendHeaders(),
    })
        .then((response: any) => response.json())
        .then((data: any) => data as Response)
        .catch((error) => {
            return null;
        });
};

const createUser = (user_details: {}): Promise<Response | null> => {
    return fetch(PageUrl, {
        method: "POST",
        headers: extendHeaders(),
        body: JSON.stringify(user_details)
    })
        .then((response: any) => response.json())
        .then((data: any) => data as Response)
        .catch((error) => {
            return null;
        });
};

const updateUser = (user_id: number, user_details: {}): Promise<Response | null> => {
    return fetch(`${PageUrl}${user_id}/`, {
        method: "PUT",
        headers: extendHeaders(),
        body: JSON.stringify(user_details)
    })
        .then((response: any) => response.json())
        .then((data: any) => data as Response)
        .catch((error) => {
            return null;
        });
};

const getUsersByRolList = (rol_value): Promise<Response | null> => {
    return fetch(PageUrl + 'getUsersByRolList/?' +
        new URLSearchParams({ rol_value: rol_value }).toString(), {
        method: "GET",
        headers: extendHeaders()
    })
        .then((response) => response.json())
        .then((data) => data as Response)
        .catch(error => {
            return null;
        });
};

const getUsersList = (): Promise<Response | null> => {
    return fetch(PageUrl, {
        method: "GET",
        headers: extendHeaders(),
    })
        .then((response: any) => response.json())
        .then((data: any) => data as Response)
        .catch((error) => {
            return null;
        });
};

const activeUser = (user_id: number, status): Promise<Response | null> => {
    return fetch(PageUrl + "updateStatus/", {
        method: "PUT",
        headers: extendHeaders(),
        body: JSON.stringify({ user_id: user_id, status: status })
    })
        .then((response: any) => response.json())
        .then((data: any) => data as Response)
        .catch((error) => {
            return null;
        });
};

const deleteUser = (user_id: number): Promise<Response | null> => {
    return fetch(`${PageUrl}${user_id}/`, {
        method: "DELETE",
        headers: extendHeaders(),
    })
        .then((response: any) => response.json())
        .then((data: any) => data as Response)
        .catch((error) => {
            return null;
        });
};

const checkIsExistsUserInStripe = (userId=null) => {
    let url = PageUrl + 'getIsExistsUserInStripe/';
    if (userId) {
        url += `?userId=${userId}`;
    }
    return fetch(url, {
        method: "GET",
        headers: extendHeaders(),
    })
        .then((response: any) => response.json())
        .catch((error) => {
            return null;
        });
};


const getMonthlyFees = (userId = null) => {
    const queryParams = new URLSearchParams();
    if (userId && userId !== undefined) {
        queryParams.set('userId', userId);
    }

    const search = queryParams.toString();

    return fetch(PageUrl + `getMonthlyFees/?${search}`, {
        method: "GET",
        headers: extendHeaders(),
    })
        .then((response: any) => response.json())
        .catch((error) => {
            return null;
        });
};

const downloadReportMonthlyFees = (userId = null) => {
    const queryParams = new URLSearchParams();
    if (userId && userId !== undefined) {
        queryParams.set('userId', userId);
    }

    const search = queryParams.toString();

    return axios({
        url: PageUrl + `downloadReportMonthlyFees/?${search}`,
        method: 'GET',
        headers: headers(),
        responseType: 'blob'
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `monthly-fees-report.xlsx`);
        document.body.appendChild(link);
        link.click();
    })
}

const getUserAccountIdByAccountId = (accountId) => {
    return fetch(PageUrl + 'getUserAccountIdByAccountId/?' +
        new URLSearchParams({ accountId: accountId }).toString(), {
        method: "GET",
        headers: extendHeaders()
    })
        .then((response) => response.json())
        .catch(error => {
            return null;
        });
};

const getAffiliatesList = (): Promise<Response | null> => {
    return fetch(PageUrl + 'getAffiliatesList/', {
        method: "GET",
        headers: extendHeaders()
    })
        .then((response) => response.json())
        .then((data) => data as Response)
        .catch(error => {
            return null;
        });
};

const UserService = {
    getUserDetails,
    createUser,
    updateUser,
    getUsersByRolList,
    getUsersList,
    activeUser,
    deleteUser,
    checkIsExistsUserInStripe,
    getMonthlyFees,
    downloadReportMonthlyFees,
    getUserAccountIdByAccountId,
    getAffiliatesList

};

export default UserService;
